export default "/fonts/parisienne-regular-webfont.ttf?0171b444ab1d7b759898e032095710ee";